import { useForm } from "react-hook-form";
import {
    CadastrarAudienciaController,
    EditarAudienciaController,
} from "../../../../Controllers/Automacao/Audiencia/AudienciaControllers";
import { IAudiencia } from "../../../../Interfaces/Automacao/Audiencia/AudienciaInterfaces";
import { Switch } from "../../../../Components/CardsPages/Forms/Switch";

interface ICadastrarEEditarAudienciaProps {
    updateList: () => void;
    setShow: (show: boolean) => void;
    audienciaValues?: IAudiencia;
}

export default function CadastrarEEditarAudiencia(
    props: ICadastrarEEditarAudienciaProps
) {
    const { register, handleSubmit, formState, reset } = useForm<IAudiencia>();

    const onSubmit = (formData: IAudiencia) => {
        if (props?.audienciaValues?.ID_AUDIENCIA) {
            EditarAudienciaController({
                ...formData,
                ID_AUDIENCIA: props?.audienciaValues?.ID_AUDIENCIA,
            }).then(() => {
                props.setShow(false);
                reset();
                props.updateList();
            });
        } else {
            CadastrarAudienciaController(formData).then(() => {
                props.setShow(false);
                reset();
                props.updateList();
            });
        }
    };

    return (
        <>
            <div className="text-center mb-10">
                <h2 className="font-weight-bold">
                    {props?.audienciaValues
                        ? "Editar Audiência"
                        : "Cadastrar Audiência"}
                </h2>
            </div>
            <form
                className="form"
                id="kt_login_signin_form"
                onSubmit={handleSubmit(onSubmit)}
            >
                <div className="form-group py-3 b-5 col-12">
                    <input
                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                            formState.errors.DS_AUDIENCIA && "is-invalid"
                        }`}
                        type="text"
                        placeholder="Nome da Audiência"
                        name="DS_AUDIENCIA"
                        defaultValue={props?.audienciaValues?.DS_AUDIENCIA}
                        ref={register({
                            required: "Insira o nome da Audiência",
                        })}
                        autoComplete="off"
                    />
                    <div className="invalid-feedback">
                        {formState.errors.DS_AUDIENCIA
                            ? formState.errors.DS_AUDIENCIA.message
                            : ""}
                    </div>
                </div>
                <div className="form-group border-bottom py-3 b-5 col-12">
                    <Switch
                        color="success"
                        label="Ativar Audiência"
                        labelPosition="top"
                        type="checkbox"
                        name="FL_ATIVO"
                        defaultChecked={
                            props?.audienciaValues
                                ? props?.audienciaValues?.FL_ATIVO
                                : true
                        }
                        ref={register()}
                    />
                </div>
                <div className="d-flex flex-wrap justify-content-center align-items-center">
                    <button
                        type="submit"
                        id="kt_login_signin_submit"
                        className="btn btn-capys font-weight-bold px-9 py-4 my-2"
                    >
                        Cadastrar
                    </button>
                </div>
            </form>
        </>
    );
}
